import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { Dashboard       } from 'src/app/beans/dashboard/dashboard';

@Injectable
({
  providedIn: 'root'
})

export class DashboardHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async getAll( token: string, siteId: number, type: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if( type > 2 || type < 0 )
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_TYPE
          )
          return undefined
        }

        try
        {
          const response = await this._request.dashboard().getAll( token, siteId, type ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

